module.exports = __webpack_public_path__ + "img/pantalones-y-shorts.289bb1b1.jpg";